import t from "@ext/localization/locale/translate";
import { GALLERY_VIEWS, type GalleryView } from "@ext/markdown/elements/gallery/model/gallery";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuTrigger,
} from "@ui-kit/Dropdown";
import { GlassToolbarIcon, GlassToolbarTriggerChevron } from "@ui-kit/GlassToolbar";
import { Icon, type IconCode } from "@ui-kit/Icon";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";

const VIEW_ICONS: Record<GalleryView, IconCode> = {
	mosaic: "layout-dashboard",
	carousel: "gallery-thumbnails",
};

interface GalleryViewActionsProps {
	view: GalleryView;
	onChange: (view: GalleryView) => void;
}

const GalleryViewActions = ({ view, onChange }: GalleryViewActionsProps) => {
	const tooltip = t("editor.gallery.view");

	return (
		<DropdownMenu>
			<Tooltip>
				<TooltipTrigger asChild>
					<DropdownMenuTrigger asChild>
						<GlassToolbarTriggerChevron aria-label={tooltip}>
							<GlassToolbarIcon icon={VIEW_ICONS[view]} />
						</GlassToolbarTriggerChevron>
					</DropdownMenuTrigger>
				</TooltipTrigger>
				<TooltipContent sideOffset={2}>{tooltip}</TooltipContent>
			</Tooltip>
			<DropdownMenuContent>
				<DropdownMenuRadioGroup onValueChange={(value) => onChange(value as GalleryView)} value={view}>
					{GALLERY_VIEWS.map((option) => (
						<DropdownMenuRadioItem key={option} value={option}>
							<Icon icon={VIEW_ICONS[option]} />
							{t(`editor.gallery.${option}`)}
						</DropdownMenuRadioItem>
					))}
				</DropdownMenuRadioGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export default GalleryViewActions;
